export enum WidgetInjectionTypeEnum {
	STANDARD= 'standard',
	INTEGRATED= 'integrated',
}

export const WidgetInjectionTypeFromIndex: {[id: number]: string} = {
	0: WidgetInjectionTypeEnum.STANDARD,
	1: WidgetInjectionTypeEnum.INTEGRATED,
};
export default WidgetInjectionTypeEnum;
